window.theme = window.theme || {};

theme.liquid_variables = {
  lang_products_add_to_bag : "Add to Bag",
  lang_products_compare_at : "Translation missing: en.products.product.compare_at",
  lang_product_unavailable : "Unavailable",
  lang_product_soldout : "Sold Out",
  lang_cart_empty : "Your bag is currently empty",
  lang_cart_empty_shop_now : "Shop Now",
  lang_cart_savings_html : "You're saving [savings]",
  lang_cart_banner_message_html : {"one":"\u003ca href=\"\/collections\/workout-towels\"\u003eadd your free workout towel\u003c\/a\u003e","other":"\u003ca href=\"\/collections\/workout-towels\"\u003eadd your {{ count }} free workout towels\u003c\/a\u003e","zero":"\u003ca href=\"\/collections\/workout-towels\"\u003efree workout towel for each beach towel\u003c\/a\u003e"},
  lang_cart_banner_message_success : "Congrats! You got free workout towels",
  settings_empty_cart_url : "/collections/beach-towels",
  settings_gift_wrapping_product_id : "39434563616841",
  settings_gift_wrapping_product_tft_id : "39434563747913",
  settings_gift_wrapping_price : "0",
  newsletter_discount_code : "Thanks10ppj"
};